import { LanguageActions, LanguageProvider } from '@web_opxp/features';
import { Provider } from 'react-redux';
import { useLocation } from 'react-router';
import { IsDebug, LocalesBaseUrl } from '../../core/env';
import './LoginApp.scss';
import LoginForm from './components/LoginForm';
import { updateEmailAction } from './core/actions';
import getStore from './core/store';
import { ILoginPageLocationState } from './types';

export default function IndexApp() {
  const location = useLocation<ILoginPageLocationState | undefined>();
  // initialize store
  const store = getStore();
  // start language feature
  store.dispatch(LanguageActions.initLanguage());
  // check if email is propagated through router state
  const email = location.state ? location.state.email || '' : '';
  if (email) {
    store.dispatch(updateEmailAction(email));
  }
  return (
    <Provider store={store}>
      <LanguageProvider
        ns={['common.common', 'common.auth', 'opxp.common', 'opxp.prereg']}
        defaultNS="common.auth"
        fallbackNS="common.common"
        localesPath={LocalesBaseUrl}
        debug={IsDebug}>
        <LoginForm />
      </LanguageProvider>
    </Provider>
  );
}
